import React, { useContext, useState } from 'react';
import { FuelSkeleton, FuelTypography, FuelIcon } from '@frete.com/fuel-react';
import {
  FuelFlex,
  FuelOriginAndDestination,
} from '@frete.com/fuel-station-react';
import AppContext from '@context';
import { JourneysStateInterface } from '@context/reducers/journeys/journeys.type';
import SkeletonOriginAndDestination from '@components/ui/Skeleton/SkeletonOriginAndDestination';
import EditAddress from '@components/ui/EditAddress';
import useAmplitude from '@hooks/useAmplitude';
import * as StyledModalMonitoring from '../ModalMonitoringStyles';
import * as Styled from './OriginAndDestinationStyles';

function OriginAndDestination() {
  const {
    state: { journeys },
  } = useContext(AppContext);
  const { amplitudeEvent } = useAmplitude();
  const [isEdit, setIsEdit] = useState(false);
  const { data: journeySelection, isFetching } =
    journeys.selection as JourneysStateInterface['selection'];
  const showButtonOfEdit =
    !isEdit && journeySelection?.journey.address.editable;

  if (isFetching) {
    return (
      <StyledModalMonitoring.Section hasDivider>
        <FuelTypography
          tag="h3"
          size="heading-md"
          weight="bold"
          spacingBottom={24}
        >
          Detalhes da viagem
        </FuelTypography>
        <FuelFlex defaultProps={{ gap: 'km3' }}>
          <SkeletonOriginAndDestination />
          <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km3' }}>
            <FuelSkeleton
              shape="pill"
              size="custom"
              width="89px"
              height="16px"
            />
            <FuelSkeleton
              shape="pill"
              size="custom"
              width="135px"
              height="16px"
            />
          </FuelFlex>
        </FuelFlex>
      </StyledModalMonitoring.Section>
    );
  }

  if (!journeySelection) {
    return null;
  }

  return (
    <StyledModalMonitoring.Section hasDivider>
      <FuelTypography
        tag="h3"
        size="heading-md"
        weight="bold"
        spacingBottom={24}
      >
        Detalhes da viagem
      </FuelTypography>
      <FuelFlex
        defaultProps={{
          justifyContent: 'space-between',
        }}
      >
        <FuelOriginAndDestination
          withCaption
          origin={journeySelection.journey.address.pickup.description}
          destination={journeySelection.journey.address.delivery.description}
          isLarge={false}
        />
        {showButtonOfEdit && (
          <Styled.WrapperIcon
            onClick={() => {
              setIsEdit(true);
              amplitudeEvent('modalMonitoring_edit_address_clicked');
            }}
          >
            <FuelIcon name="edit" size="tiny" iconStyle="filled" />
          </Styled.WrapperIcon>
        )}
      </FuelFlex>
      <EditAddress
        isShow={isEdit}
        journeyId={journeySelection.journey.id}
        renderLocation="modalMonitoring"
        onCancel={() => setIsEdit(false)}
        onSucess={() => setIsEdit(false)}
      />
    </StyledModalMonitoring.Section>
  );
}

export default OriginAndDestination;
